/*
 * @Author: wblijinyang
 * @FilePath: /code/mall-fe/src/views/ProductList.cscec3b.tsx
 * @Description:
 */
import Layout from 'comps/Layout';
import ProductListComp from 'comps/h5/Search/components/ProductList';
import SearchInput from 'comps/SearchInput';
import { toQueryString } from 'libs/utils';
import { useRouter } from 'next/router';
import { useState } from 'react';

export default function ProductListView() {
  const router = useRouter();
  return (
    <Layout
      header={null}
      footer={null}
      keywords="数字化,供应链管理,数字采购,供应链金融"
      description={`${''}通过数字化供应链管理、数字采购、供应链金融等产品和服务，实现产业链上下游协作，进而降本增效`}
      title={router.query.categoryName ? `${router.query.categoryName}-商品列表` : '商品列表'}
    >
      <MallList />
    </Layout>
  );
}

function MallList() {
  const router = useRouter();
  const [pCondition, setCondition] = useState({ key: '' });

  const onSearch = (key) => {
    setCondition((v) => ({ ...v, key }));
    router.replace(
      `/product/list${toQueryString({
        ...router.query,
        key,
      })}`,
    );
  };

  return (
    <>
      <SearchInput
        isSearchSku
        onSearch={onSearch}
        watchRouter={true}
        onClickSearchIcon={onSearch}
      />
      <ProductListComp toolHeight={60} pCondition={pCondition} />
      <style jsx>{`
        .box {
          background-color: #f7f7f7;
        }
      `}</style>
    </>
  );
}
